import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import {
    ActionTableCell,
    CheckboxTableRow,
    ExTable,
    SelectionFixedFooter,
    TableBody,
    TableHead,
    TableWrapper,
    useMultipleCheckForm,
} from 'components/shared/widget'
import { useDownloadCsvVendorsApi, useFetchVendorsApi } from 'api/vendor'
import { Vendor, VendorSearchForm } from 'entities/vendor'
import { Pagination } from 'components/shared/pagination'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { vendorColumnInfoList, VendorTableData } from './vendor_table'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import qs from 'qs'
import { InputField } from 'components/shared/input'
import { useState } from 'react'
import { EditVendorForm, NewVendorForm } from './vendor_form'
import { Flex } from 'components/shared/flex'

type Props = {
    history: H.History
}

const VendorsPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const params = useQuery<VendorSearchForm>()
    const preSearchForm = useForm<VendorSearchForm>(params)
    const searchForm = useForm<VendorSearchForm>(params)
    const api = useFetchVendorsApi(searchForm)
    const downloadCsvApi = useDownloadCsvVendorsApi(searchForm)
    const checkIdForm = useMultipleCheckForm<Vendor>()
    const vendorDisplaySetting = useDisplaySetting(vendorColumnInfoList(searchForm), 'Vendor')
    const [selectedVendor, setSelectedVendor] = useState<Vendor>({})
    const [showEdit, setShowEdit] = useState<boolean>(false)

    useEffect(() => {
        api.execute()
    }, [])

    const handleClickRemoveFilter = (key: keyof VendorSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object, page: api.pageSet.page, perPage: api.pageSet.perPage })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`vendors?${queryParams}`)
        }
    }, [searchForm.object])

    const handleClickEdit = (vendor: Vendor) => {
        setSelectedVendor(vendor)
        setShowEdit(true)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(downloadCsvApi.loading)
    }, [downloadCsvApi.loading])

    return (
        <>
            <EditVendorForm
                vendor={selectedVendor}
                show={showEdit}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    api.execute()
                    setShowEdit(false)
                }}
            />
            <ContentHeader
                headerTitle="委託先"
                left={
                    <>
                        {/* <CopyTableButton /> */}

                        <NewVendorForm
                            onComplete={() => {
                                api.execute()
                            }}
                        />
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} />
                    </>
                }
                right={<>{/* <DisplaySettingModal displaySettings={displaySettings} /> */}</>}
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <Flex alignItems="center">
                    <InputField
                        attr="name"
                        form={preSearchForm}
                        placeholder="施設名"
                        onPressEnter={() => {
                            searchForm.updateObject('name', preSearchForm.getValue('name'))
                        }}
                        style={{ marginBottom: 0, width: 250 }}
                    />
                </Flex>
                <Flex alignItems="center">
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {api.response.count.toLocaleString()}件</div>
                </Flex>
            </Flex>
            <ContentBody>
                <TableWrapper showFooter={checkIdForm.form.object.items.length > 0} contentHeaderCount={2}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <CheckboxTableRow head allCheck allItems={api.response.results} multipleCheckForm={checkIdForm} showEdit>
                                <ActionTableCell th width={60} />
                                <TableHeads displaySetting={vendorDisplaySetting} />
                            </CheckboxTableRow>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={vendorDisplaySetting.getColumnLength()}>
                            {api.response.results.map((vendor: Vendor) => {
                                return (
                                    <CheckboxTableRow
                                        key={`vendor-${vendor.id}`}
                                        item={vendor}
                                        multipleCheckForm={checkIdForm}
                                        onClickEdit={() => handleClickEdit(vendor)}
                                    >
                                        <ActionTableCell
                                            action="edit"
                                            onClick={() => {
                                                setSelectedVendor(vendor)
                                                setShowEdit(true)
                                            }}
                                        />
                                        <VendorTableData vendor={vendor} displaySetting={vendorDisplaySetting} />
                                    </CheckboxTableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                </TableWrapper>
            </ContentBody>

            <SelectionFixedFooter
                ids={checkIdForm.ids()}
                onClickReset={() => checkIdForm.form.resetForm()}
                searchForm={searchForm}
                searchAttr="id"
                tableName="Vendor"
            ></SelectionFixedFooter>
        </>
    )
}

export default withRouter(VendorsPage)
